<template>
  <div>
    <a-card :title="$t('复核')">
      <a-button slot="extra" type="primary" ghost @click="goBack"><a-icon type="left" />{{ $t("返回") }}</a-button>

      <a-form-model ref="form" :model="form" :label-col="{ span: 8 }" :wrapper-col="{ span: 16 }">
        <a-row>
          <a-col :span="24" style="width: 380px">
            <a-form-model-item prop="pallet_quantity" :label="$t('托盘数量')">
              <a-input-number v-model="form.pallet_quantity" style="width: 100%" />
            </a-form-model-item>
          </a-col>
          <a-col :span="24" style="width: 380px">
            <a-form-model-item prop="remark" :label="$t('备注')">
              <a-input v-model="form.remark" allowClear />
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>

      <a-divider />
      <a-row :gutter="12">
        <a-col :span="4" style="width: 256px; margin-bottom: 12px">
          <a-input-search v-model="filterValue" :placeholder="$t('请扫描货品条码')" />
        </a-col>
      </a-row>

      <a-spin :spinning="loading">
        <div>
          <a-table
            rowKey="id"
            size="small"
            :columns="curColumns"
            :data-source="filteredMaterialItems"
            :scroll="{ x: 1600 }"
            :pagination="false"
          >
            <div slot="total_quantity" slot-scope="value, item">
              <a-input-number v-model="item.total_quantity" size="small" @change="changeQuantity(item)" />
            </div>
            <div slot="total_weight" slot-scope="value, item">
              <a-input-number v-model="item.total_weight" size="small" />
            </div>
            <div slot="total_area" slot-scope="value, item">
              <a-input-number v-model="item.total_area" size="small" />
            </div>
            <div slot="total_volume" slot-scope="value, item">
              <a-input-number v-model="item.total_volume" size="small" />
            </div>
            <!-- <div slot="charge_value" slot-scope="value, item">
              <a-input-number v-model="item.charge_value" size="small" />
            </div> -->
            <div slot="action" slot-scope="value, item, index">
              <a-button-group size="small">
                <a-button type="danger" @click="removeMaterial(index)">{{ $t("删除") }}</a-button>
              </a-button-group>
            </div>
          </a-table>
        </div>
      </a-spin>

      <div style="margin-top: 32px">
        <a-popconfirm :title="$t('确定创建吗?')" @confirm="create">
          <a-button type="primary" :loading="loading">{{ $t("创建") }}</a-button>
        </a-popconfirm>
      </div>
    </a-card>
  </div>
</template>

<script>
import { deliveryMaterialOption } from "@/api/option";
import { deliveryRecordCreate } from "@/api/stockOut";
import moment from "moment";
import NP from "number-precision";
import { mapState } from "vuex";

export default {
  data() {
    return {
      description: this.$t("详情"),
      form: { pallet_quantity: 0, remark: "" },
      columns: [
        {
          title: this.$t("序号"),
          dataIndex: "index",
          fixed: "left",
          width: 60,
          customRender: (value, item, index) => {
            return index + 1;
          },
        },
        {
          title: this.$t("货品名称"),
          dataIndex: "material_name",
          fixed: "left",
          width: 150,
        },
        {
          title: this.$t("复核数量"),
          width: 100,
          scopedSlots: { customRender: "total_quantity" },
        },
        {
          title: this.$t("复核重量(吨)"),
          dataIndex: "total_weight",
          width: 120,
          scopedSlots: { customRender: "total_weight" },
        },
        {
          title: this.$t("复核面积(平方米)"),
          dataIndex: "total_area",
          width: 140,
          scopedSlots: { customRender: "total_area" },
        },
        {
          title: this.$t("复核体积(立方米)"),
          dataIndex: "total_volume",
          width: 140,
          scopedSlots: { customRender: "total_volume" },
        },
        // {
        //   title: this.$t("计费量"),
        //   dataIndex: "charge_value",
        //   scopedSlots: { customRender: "charge_value" },
        //   key: "charge_value",
        // },
        {
          title: this.$t("货品编号"),
          dataIndex: "material_number",
          key: "material_number",
        },
        {
          title: this.$t("待复核数量"),
          dataIndex: "remain_quantity",
          key: "remain_quantity",
        },
        {
          title: this.$t("批次"),
          dataIndex: "batch_number",
          key: "batch_number",
        },
        {
          title: this.$t("单位"),
          dataIndex: "unit",
          key: "unit",
        },
        {
          title: this.$t("计费单位"),
          dataIndex: "charge_unit_display",
          key: "charge_unit",
        },
        {
          title: this.$t("操作"),
          dataIndex: "action",
          key: "action",
          fixed: "right",
          scopedSlots: { customRender: "action" },
        },
      ],
      loading: false,
      delivery_order_id: "",
      deliveryMaterialItems: [],
      filterValue: "",
    };
  },
  computed: {
    ...mapState({
      curWarehouse: (state) => state.user.currentWarehouse,
    }),
    filteredMaterialItems() {
      let filteredMaterialItems = [];
      for (let item of this.deliveryMaterialItems) {
        if (item.material_number.includes(this.filterValue)) {
          filteredMaterialItems.push(item);
        }
      }

      if (this.filterValue && this.filterValue != "" && filteredMaterialItems.length == 0) {
        this.$message.warn(`${this.$t("货品")}[${this.filterValue}]${this.$t("不存在")}`);
      }

      return filteredMaterialItems;
    },
    enableCharge() {
      return this.$store.state.user.enableCharge;
    },
    curColumns() {
      const items = [];
      for (const item of this.columns) {
        if (!this.enableCharge && item.key === "charge_value") {
          continue;
        }

        if (!this.enableCharge && item.key === "charge_unit") {
          continue;
        }

        items.push(item);
      }
      return items;
    },
  },
  methods: {
    moment,
    initData() {
      this.delivery_order_id = this.$route.query.id;
      this.getMaterial();
    },
    getMaterial() {
      deliveryMaterialOption({
        page_size: 999999,
        delivery_order: this.$route.query.id,
        is_completed: false,
      })
        .then((data) => {
          console.log(data.results);
          let materialItems = data.results.map((item) => {
            return {
              ...item,
              id: item.id,
              delivery_material: item.id,
              material_name: item.material_name,
              material_number: item.material_number,
              remain_quantity: item.remain_quantity,
              // charge_value: this.getChargeValue(item, item.remain_quantity),
              total_quantity: item.remain_quantity,

              total_weight: NP.times(item.unit_weight, item.remain_quantity, 0.001),
              total_area: NP.times(item.unit_area, item.remain_quantity),
              total_volume: NP.times(item.unit_volume, item.remain_quantity),

              charge_unit: item.charge_unit,
              unit: item.unit,
              batch_number: item.batch_number,
            };
          });

          this.deliveryMaterialItems = [...materialItems];
        })
        .finally(() => {
          this.loading = false;
        });
    },
    removeMaterial(index) {
      this.deliveryMaterialItems.splice(index, 1);
    },
    create() {
      if (this.deliveryMaterialItems.length == 0) {
        this.$message.warn(this.$t("未添加货品"));
        return;
      }

      let formData = {
        ...this.form,
        delivery_order: this.delivery_order_id,
        delivery_record_material_items: this.deliveryMaterialItems,
      };

      this.loading = true;
      deliveryRecordCreate(formData)
        .then((data) => {
          this.$message.success(this.$t("创建成功"));
          this.goBack();
        })
        .finally(() => {
          this.loading = false;
        });
    },
    goBack() {
      this.$router.go(-1);
    },
    addSerialNumber(item) {
      item.total_quantity += 1;
    },
    getChargeValue(item, quantity) {
      if (item.charge_unit === "quantity") {
        return quantity || 0;
      } else if (item.charge_unit === "ton") {
        return NP.times(quantity, item.weight || 0, 0.001);
      } else if (item.charge_unit === "cube") {
        return NP.times(quantity, item.volume || 0);
      }
      return 0;
    },
    changeQuantity(item) {
      item.total_weight = NP.times(item.total_quantity, item.unit_weight, 0.001);
      item.total_area = NP.times(item.total_quantity, item.unit_area);
      item.total_volume = NP.times(item.total_quantity, item.unit_volume);
    },
  },
  mounted() {
    this.initData();
  },
};
</script>
